import { Box } from '@mui/material'
import React, { useEffect, useRef } from 'react'
interface Props {

}
const ScrollToOnMount:ReactFC<Props> = (props) => {
  const containerEl = useRef<HTMLDivElement>()

  useEffect(() => {
    containerEl.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    })
  }, [])

  return (
    <Box ref={containerEl}>
      {props.children}
    </Box>
  )
}
export default ScrollToOnMount
